import { observer } from 'mobx-react';
import classNames from 'classnames';
import styles from './SoapEntryHeaderRight.module.scss';
import { Icon, IconType } from '@components/Icon';
import { EntryPageTestAttributes } from 'chaika-test-attributes';
import { store } from '@store';

export const SoapEntryHeaderRight = observer(() => {
    const {
        entry,
        viewPort: { isMobileSize },
    } = store;

    const onToggleClick = () => {
        entry.setShowMobileRightMenu(!entry.mobileShowRightMenu);
    };

    if (!isMobileSize) {
        return null;
    }

    return (
        <button
            className={classNames([styles.toggleButton, entry.mobileShowRightMenu && styles.open])}
            onClick={onToggleClick}
            data-test={EntryPageTestAttributes.HeaderList}
        >
            <div className={classNames([styles.icon, entry.mobileShowRightMenu && styles.iconOpen])}>
                <Icon type={IconType.ARROW_DOWN_REDESIGN} />
            </div>
        </button>
    );
});
